import { useQuery } from '@tanstack/react-query';

import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { fetchPost } from '../api';

export const usePost = (postId: string) => {
  const { workspaceId } = useWorkspaceId();
  return useQuery({
    queryKey: ['post', postId],
    queryFn: ({ signal }) => fetchPost(workspaceId, postId, signal),
  });
};
